export enum CartIoFormat {
    Json = 'json',
    Csv = 'csv',
}